import { Component, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { NDCOfferManagementCapabilitiesPage } from 'src/app/model/page/ndc-offer-management-capabilities-page';
import { Section } from 'src/app/model/shared/section';
import { TabMenu } from 'src/app/model/shared/tab-menu';
import { ContentfulService } from 'src/app/service/contentful.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-ndc-offer-management-capabilities-page',
  templateUrl: './ndc-offer-management-capabilities-page.component.html',
  styleUrls: ['./ndc-offer-management-capabilities-page.component.scss']
})
export class NDCOfferManagementCapabilitiesPageComponent implements OnInit {
  tabMenu: TabMenu = {} as TabMenu;
  sectionsMap = new Map();
  selectedIndex: number = 0;
  collapsedStatusArray: boolean[] = [];

  OfferManagementTitle: string = '';
  OfferManagementLink: string = '';
  linkTextSeperator: string = '';
  OrderManagementTitle: string = '';
  OrderManagementLink: string = '';

  toggleMap = new Map();
  toggle = { toggle: true, accordionClass: 'not-collapsed', arrowIconsClass: 'icon-arrowUp', sectionBorderTopClass: 'border-blue', activeClass: 'active' };
  collapsed = { toggle: false, accordionClass: 'collapsed', arrowIconsClass: 'icon-arrowDown', sectionBorderTopClass: 'border-darkblack', activeClass: 'title-hover' };

  pageName = 'NDC Offer Management Capabilities';
  ndcOfferManagementCapabilitiesPage: NDCOfferManagementCapabilitiesPage = {} as NDCOfferManagementCapabilitiesPage;

  constructor(private contentfulService: ContentfulService) {}

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'offer-management-capabilities') {
        this.ndcOfferManagementCapabilitiesPage.htmlTitle = title.htmlTitle;
      }
    });
    this.toggleMap.set(true, this.toggle);
    this.toggleMap.set(false, this.collapsed);
    this.toggleMap.set(undefined, this.collapsed);

    const menuQuery = { 'fields.name': 'Tab Menu#Offer Management' };
    this.contentfulService.getMenuContentWithItems(menuQuery).then((menuItems) => {
      this.tabMenu.links = menuItems[0]?.fields.jsonData;
    });

    const pageQuery = { 'fields.title': this.pageName };
    this.ndcOfferManagementCapabilitiesPage.sections = [];

    this.contentfulService.getPageContentWithEntries(pageQuery).then((ndcoffermanagementcapabilities) => {
      this.mapBanner(ndcoffermanagementcapabilities);
      this.mapSections(ndcoffermanagementcapabilities);
      this.mapLinkNavigationDetails();
    });
    this.contentfulService.getPageContentWithItems(pageQuery).then((ndcoffermanagementcapabilities) => {
      ndcoffermanagementcapabilities.forEach((entry: any) => {
        this.ndcOfferManagementCapabilitiesPage.htmlTitle = entry.fields.htmlTitle;
      });
    });
  }

  private mapSections(ndcoffermanagementcapabilities: Entry<any>[]) {
    ndcoffermanagementcapabilities
      .filter((entry) => ModelValidator.isSection(entry))
      .forEach((entry) => {
        this.mapEntryToSection(entry);
      });

    let sectionArray: Section[] = [];

    this.ndcOfferManagementCapabilitiesPage.sections.filter((section) => {
      const key = section.group.split('#').pop();
      sectionArray = this.sectionsMap.get(key);
      // // console.log(sectionArray);
      if (sectionArray === undefined || sectionArray.length == 0) {
        sectionArray = [];
      }
      sectionArray.push(section);
      sectionArray.sort((a, b) => a.order - b.order);
      this.sectionsMap.set(key, sectionArray);
    });

    // console.log(this.sectionsMap);
  }

  getNonAccordianSections(key: string): Section[] {
    let sectionArray: Section[] = [];
    if (this.sectionsMap.get(key)) {
      sectionArray = this.sectionsMap.get(key);
      sectionArray = sectionArray.filter((section: Section) => section.category !== 'accordian');
    }
    return sectionArray.sort((a, b) => a.order - b.order);
  }

  getAccordianSections(key: string): Section[] {
    let sectionArray = [];
    if (this.sectionsMap.get(key)) {
      sectionArray = this.sectionsMap.get(key);
    }
    return sectionArray.filter((section: Section) => section.category === 'accordian');
  }

  private mapBanner(ndcoffermanagementcapabilities: Entry<any>[]) {
    ndcoffermanagementcapabilities
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToSection(entry: Entry<any>) {

    let givenTitle:any=entry.fields['title'] as string;
    let pageTitle=givenTitle.split('#').pop();

    this.ndcOfferManagementCapabilitiesPage.sections.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      subBody: entry.fields['subBody'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      category: entry.fields['category'] as string,
      titleColorClass: entry.fields['sectionClass'] as string,
      heading: entry.fields['heading'] as string
    });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let imageDetails: any = entry.fields['image'];
    this.ndcOfferManagementCapabilitiesPage.banner ={
      title:  entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: imageDetails.fields.file.url,
      video: ''
    };
  }

  toggleCollapsed(index: number) {
    this.collapsedStatusArray[index] = !this.collapsedStatusArray[index];
  }

  private mapLinkNavigationDetails() {
    const query = { 'fields.title': 'NDC Offer Management Capabilities' };
    this.contentfulService.getPageContentWithItems(query).then((labelItems) => {
      this.OfferManagementTitle = labelItems[0]?.fields.constants[0].OfferManagementTitle;
      this.OfferManagementLink = labelItems[0]?.fields.constants[0].OfferManagementLink;
      this.linkTextSeperator = labelItems[0]?.fields.constants[0].linkTextSeperator;
      this.OrderManagementTitle = labelItems[0]?.fields.constants[0].OrderManagementTitle;
      this.OrderManagementLink = labelItems[0]?.fields.constants[0].OrderManagementLink;
      // console.log('labelItems', labelItems);
    });
  }
}
